<template>
<div class="scrolling">
 <el-container >
    <el-main>
    <div
        lang="en"
        class="sign-up-form"
        v-loading="loading"
        element-loading-text="Sign up ..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0.0, 0.0, 0.0, 0.0)"
    >
        <el-form  label-position="left" label-width="130px" ref="form" :rules="form.rules" :model="form" size="medium">
            <el-form-item label="First Name" class="form-label">
                <el-input v-model="form.firstName" placeholder="eg. Jane"></el-input>
            </el-form-item>
            <el-form-item label="Last Name" class="form-label">
                <el-input v-model="form.lastName" placeholder="eg. Doe"></el-input>
            </el-form-item>
            <el-form-item label="Email address" class="form-label">
                <el-input v-model="form.email" placeholder="eg. my@email.com"></el-input>
            </el-form-item>
            <el-form-item label="Password" class="form-label">
                <el-input v-model="form.password" show-password></el-input>
            </el-form-item>
            <el-form-item label="Confirm Password" class="form-label">
                <el-input v-model="form.confirmPassword" show-password></el-input>
            </el-form-item>
            <div class="password-warning">
            <span>Note: Password must be minimum eight characters, </span><br>
            <span>at least one letter and one number.</span>
            </div>
                <el-form-item prop="recaptcha" style="margin-top:20px;">
                <vue-recaptcha  ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" :sitekey="recaptchaSitekey" :loadRecaptchaScript="true"></vue-recaptcha>
            </el-form-item>
            <div style="text-align: center; margin: 30px 0 0 0; display: inline-block">
            <el-form-item>
                <el-button @click="onClose">Cancel</el-button>
                <el-button type="primary" @click="submitForm('form')">Create Login</el-button>
            </el-form-item>
            </div>
            </el-form>
        </div>
        </el-main>
         </el-container>
        <div>
        <el-dialog :visible.sync="forgotPasswordVisible" width="35%"  append-to-body>
        <span slot="title" class="email">Email</span>
        <div>
          <el-form v-loading="sendEmailLoading"
        element-loading-text="Please wait..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0.0, 0.0, 0.0, 0.0)" @submit.prevent.native="sendEmail">
            <el-input v-model="email"></el-input>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="forgotPasswordVisible = false"
            >Cancel</el-button
          >
          <el-button type="primary" @click="sendEmail">Confirm</el-button>
           <el-link @click="signUp">Sign up</el-link>
        </span>
    </el-dialog>
    </div>
    </div>
</template>


<script>
import VueRecaptcha from 'vue-recaptcha';
import axios from '../client';
import { showMessage } from '../utils';
import {
    mapState,
} from "vuex";

export default {
    name: "AdminSignUp",
    components: {
        VueRecaptcha,
    },
    props: ['onClose'],
    data: function () {
        return {
            recaptchaSitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
        }
    },
    mounted: function(){
        this.listenOnCloseEvent();
    },
    methods: {
        async submitForm(form) {
            if (
                this.$refs[form].validate(async valid => {
                    if (valid && this.form.recaptcha) {
                        await this.SignUp();
                        this.onClose();
                    } 
                })
            );
        },
        async SignUp(){
            try{
                this.$store.commit('user/setAuthLoading', true);
                if(this.form.password === this.form.confirmPassword){
                    await axios.post('/api/user/signup',this.form)
                    showMessage('Sign up successful. Please check your email to verify your account.', 'success')
                    this.$router.push({
                        path: '/thanksforsignup'
                    });
                }
                this.$store.commit('user/setAuthLoading', false);
            } catch(error){
                showMessage(error.message, 'error')
                this.$store.commit('user/setAuthLoading', false);
            }
        },
        onCaptchaVerified(recaptchaToken) {
            this.form.recaptcha = recaptchaToken;
            this.$refs.form.validateField('recaptcha');
        },

        onCaptchaExpired() {
            if(this.$refs.recaptcha){
                this.$refs.recaptcha.reset();
            }
        },
        listenOnCloseEvent(){
            this.$eventHub.$on('RESET_FORM',() =>{
                this.onCaptchaExpired();
                this.$store.commit('user/resetUserDataForm');
            })
        },
    },
    computed: {
        ...mapState({
            form: state => state.user.signUpForm,
            loading: state => state.user.authLoading
        }),
    }
};
</script>

<style scoped>
.scrolling{
  height: 800px;
  overflow: auto;
}
.el-main {
    width: 500px;
    min-width: 500px;
    max-width: 500px;
    margin: 10px auto;
    
    }
.sign-up-login-form{
    padding-bottom:30px;
}
.user {
    position: absolute;
    right: 20px;
    bottom: 50%;
    transform: translateY(50%);
    color:white;
}
.user:hover{
    color: #3e9dfb;
}
.password-warning{
    font-family: PP Telegraf, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 130%;
}
.sign-up-form{
    height: 100%;
    overflow-y: auto;
}

.form-label
{
    font-family: PP Telegraf, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 130%;
}
</style>